import env from '../Config/env';

/**
 * Variantes derivadas de env.WHATSAPP_PHONE para uso em props/labels.
 *
 * Formato canônico de entrada (env): "+552140209749"
 *
 * Variantes computadas (uma vez, no carregamento do módulo — CRA inlina
 * env.WHATSAPP_PHONE em build time):
 *
 *   withDDI     → "+552140209749"   FloatingWhatsApp, tel: href com DDI
 *   digits      → "552140209749"    api.whatsapp.com URL (Whatsapp component)
 *   displayBR   → "(21) 4020-9749"  display BR formatado (strip +55)
 *   localOnly   → "4020-9749"       só o número, sem DDD/DDI (label curto)
 *   telLocal    → "40209749"        tel: href no formato local legacy
 *
 * Origem: TD-010 — telefone hardcoded em 5 sites de UI; migração para
 * leitura única do env.WHATSAPP_PHONE com helper de formatação.
 */

const stripNonDigits = (s) => String(s || '').replace(/\D/g, '');

const formatBR = (digits) => {
	if (digits.length === 8) return `${digits.slice(0, 4)}-${digits.slice(4)}`;
	if (digits.length === 9) return `${digits.slice(0, 5)}-${digits.slice(5)}`;
	if (digits.length === 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
	if (digits.length === 11) return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
	return digits;
};

const raw = env.WHATSAPP_PHONE || '';
const allDigits = stripNonDigits(raw);
const noCountry = allDigits.startsWith('55') ? allDigits.slice(2) : allDigits;
// Telefones fixos (8 dígitos) começam com 2-5; o atual (40209749) é fixo no DDD 21.
const noCountryNoDDD = noCountry.length === 10
	? noCountry.slice(2)
	: noCountry.slice(3);

export const phone = {
	withDDI: raw,
	digits: allDigits,
	displayBR: formatBR(noCountry),
	localOnly: formatBR(noCountryNoDDD),
	telLocal: noCountryNoDDD,
};

export default phone;
